import moment from 'moment-timezone';
import React from 'react';
import { setDefaultLocale } from 'react-datepicker';
import { useSelector } from 'react-redux';

import { selectedLanguageSelector } from '../store/selectors/languageSelectors';
import LocalizationContext from './LocalizationContext';
import supportedLocalizations from './localizations/supportedLocalizations';

interface Props {
  children: React.ReactNode;
}

function LocalizationProvider(props: Props) {
  const { children } = props;
  const selectedLanguage = useSelector(selectedLanguageSelector);
  const localization = supportedLocalizations[selectedLanguage];
  const { language } = localization;
  const { locale } = language;
  // Do not change to moment.updateLocale
  moment.locale(locale);
  setDefaultLocale(locale);

  return <LocalizationContext.Provider value={localization}>{children}</LocalizationContext.Provider>;
}

export default LocalizationProvider;
